export default "__VITE_ASSET__GwA1sUmkflmVM_q25Qqydw__";